import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PantheonNetworkEmbed from "./pages/PantheonNetworkEmbed";
import { PANTHEON_NETWORK_EMBED_PATH } from "./pantheonNetworkEmbedRoute";

export { PANTHEON_NETWORK_EMBED_PATH } from "./pantheonNetworkEmbedRoute";

export default function PantheonNetworkEmbedApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={PANTHEON_NETWORK_EMBED_PATH} element={<PantheonNetworkEmbed />} />
      </Routes>
    </BrowserRouter>
  );
}
